import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';

export type CreateCorporateLeadParams = {
  mobileNumber: string;
  fullName: string;
  message: string;
};

export class CorporateLeadApi {
  static create = async (params: CreateCorporateLeadParams) => {
    return await authAxios.post(`${API_V1_BASE}/corporate_leads`, snakes(params));
  };
}
